$exso_sheets_shifts_class $exso_sheets
	paths / \/api/shifts
	shift *
		1 @ \Ночная
		2 @ \Дневная
	order_by /
		\date
		\shift_num
	columns *
		value *
			title @ \Бурение
			unit @ \п.м.
		fuel *
			title @ \ГСМ
			unit @ \л
		redrill *
			title @ \Перебур
			unit @ \скв.
		tech_downtime *
			title @ \Тех. простой
			unit \minutes
		org_downtime *
			title @ \ОФР
			unit \minutes
		downtime *
			title @ \Простой
			unit \minutes
		fuel__value *
			title @ \Уд. ГСМ
			unit \
		wells_count *
			title @ \Количество скважин
			unit @ \скв.
		device * title @ \Станок
		place * title @ \Месторождение
		date * title @ \Дата
		shift * title @ \Смена
		supervisor * title @ \МБУ
		note * title @ \Примечание
		block * 
			title @ \Блоки
			type \list
		compressor * title @ \Компрессор
		fuel_compressor *
			title @ \Заправка компрессора
			unit @ \л
		fuel_device *
			title @ \Заправка станка
			unit @ \л
		hours_device *
			title @ \Моточасы БУ
			unit \minutes
		hours_compressor *
			title @ \Моточасы КУ
			unit \minutes
